import { FilterItemValue } from "./";

export interface FilterItem {
    label: string;
    values: FilterItemValue[];
}
